import React from 'react';
import { useLocation } from 'react-router-dom';
import { TabletMax, MobileMax, HorizontalMobileMax } from './UIValues'

export function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = React.useState<{ width?: number, height?: number }>({
        width: undefined,
        height: undefined,
    });
    React.useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}

export const IsTablet = (size?: number): boolean => (size || 0) < TabletMax

export const IsMobile = (size?: number): boolean => (size || 0) < MobileMax

export const IsHorizontalMobile = (size?: number): boolean => (size || 0) < HorizontalMobileMax


export const RETURN_TO_DASHBAORD = "dashboard"
export const RETURN_TO_DASHBAORD_QUERY = "source=" + RETURN_TO_DASHBAORD
export function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}


export function delay(time: number) {
    return new Promise(resolve => setTimeout(resolve, time));
}
